import { mqMin } from '../../breakpoints';

const baseVariantShared = {
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  gap: '80px 80px',
  justifyContent: 'center',
  width: '100%',
  marginLeft: 0,
  '& > li': {
    flexBasis: 'calc(80% - 80px)',
  },
  [mqMin.mobile]: {
    '& > li': {
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: 'calc(50% - 80px)',
    },
  }
};

const baselayouts = {
  default: {
    ...baseVariantShared
  },
  oneLine: {
    ...baseVariantShared,
    [mqMin.tablet]: {
      flexWrap: 'nowrap',
      '& > li': {
        // helps normalize particularly wide logos
        flexBasis: 'auto',
        maxWidth: '25%'
      },
    }
  },
  autoWrap: {
    ...baseVariantShared,
    [mqMin.tabletLandscape]: {
      '& > li': {
        flexBasis: 'auto',
        maxWidth: '25%'
      }
    }
  },
  threeWrap: {
    ...baseVariantShared,
    [mqMin.tabletSmall]: {
      '& > li': {
        flexBasis: 'calc(33% - 80px)',
      }
    }
  },
  fourWrap: {
    ...baseVariantShared,
    [mqMin.tabletLandscape]: {
      '& > li': {
        flexBasis: 'calc(25% - 80px)',
      }
    }
  },
  fiveWrap: {
    ...baseVariantShared,
    [mqMin.tabletLandscape]: {
      '& > li': {
        flexBasis: 'calc(20% - 80px)',
      }
    }
  },
  twoOneTwo: {
    listStyle: 'none',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '80px',
    '& > li:nth-child(3n+3)': {
      gridColumnStart: '1',
      gridColumnEnd: '3'
    }
  },
};

const layouts = {
  products: {
    chart: baselayouts,
    chartblog: baselayouts,
    co: baselayouts,
    edu: baselayouts,
    scale: baselayouts,
    spark: baselayouts
  }
};

export type layoutVariantsType = 'oneLine' | 'autoWrap' | 'threeWrap' | 'fourWrap' | 'fiveWrap' | 'twoOneTwo';
export const layoutVariants = Object.keys(layouts) as layoutVariantsType[];

export default layouts;
